import request from '@/utils/request'

//修改个人信息
export function edituserinfo (data) {
  return request({
    url: '/common/user/edit',
    method: 'POST',
    data
  })
}

//修改密码
export function edituserresetpassword (data) {
  return request({
    url: '/common/auth/reset-password',
    method: 'POST',
    data
  })
}

// 跳过修改密码
export function useredit (data) {
  return request({
    url: '/common/user/edit',
    method: 'POST',
    data
  })
}

//更换手机号
export function changeusermobile (data) {
  return request({
    url: '/common/user/change-mobile',
    method: 'POST',
    data
  })
}

//获取用户信息
export function getuserinfo (params) {
  return request({
    url: '/common/user/get-info',
    method: 'GET',
    params
  })
}

//发送短信验证码
export function sendsmscode (data) {
  return request({
    url: '/common/sms/send-code',
    method: 'POST',
    data
  })
}

//注册
export function registerUaserName (data) {
  return request({
    url: '/common/auth/register',
    method: 'POST',
    data
  })
}

// 刷新token
export function refreshToken (params) {
  return request({
    url: '/common/auth/refresh-token',
    method: 'GET',
    params
  })
}

//发送邮箱验证码
export function sendemailcode (data) {
  return request({
    url: '/common/email/send-code',
    method: 'POST',
    data
  })
}

//忘记密码
export function forgetpw (data) {
  return request({
    url: '/common/auth/forget',
    method: 'POST',
    data
  })
}

//修改校外邮箱
export function edituserEmail (data) {
  return request({
    url: '/common/user/change-email',
    method: 'POST',
    data
  })
}

// 获取网站友情链接
export function getLinkList (params) {
  return request({
    url: '/portal/links/get-list',
    method: 'GET',
    params
  })
}